import Tooltip from '@material-ui/core/Tooltip';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { ReactComponent as MoreIcon } from '@assets/icons/more_icon.svg';

import DeleteModal from '@components/DeleteModal';
import NoData from '@components/NoData';
import { toastError, toastSuccess } from '@components/Toast';

import { supplierTypeWiseFieldParams } from '@features/filter/static/filterUtil';
import DownloadSticker from '@features/supplier/component/DownloadSticker';
import TagMaterials from '@features/supplier/component/TagMaterials';
import TagSupplier from '@features/supplier/component/TagSupplier';
import MaterialsLeftPanel from '@features/design/components/MaterialsLeftPanel';
import Embelishment from '@features/materials/components/Embelishment';
import Washing from '@features/materials/components/Washing';

import { fetchSupplierTypeWiseList } from '@store/actions/SupplierAction';

import ApiClient from '@lib/apiClient';

import { capitalizeFirstLetter, convertDateToLocal, convertNumberToUSFormat } from '@utils/Util';

import { MATERIALS_TYPE } from '@/constants/constant';

const SupplierTypeWiseMaterialList = ({ supplierType, isPopupView = false, isAdd, setIsAdd }) => {
	const [selectedType, setSelectedType] = useState(MATERIALS_TYPE.FABRIC);
	const [isInventory, setIsInventory] = useState(true);
	const [, setIsLoading] = useState(true);
	const [isShowMaterial, setIsShowMaterial] = useState(isAdd);
	const [showSupplier, setShowSupplier] = useState(false);
	const [isEdit, setIsEdit] = useState('');
	const [selectedItem, setSelectedItem] = useState(null);
	const [selectedMaterialId, setSelectedMaterialId] = useState(null);
	const [selectedMaterials, setSelectedMaterials] = useState([]);
	const [isAllCheckedButtonClicked, setIsAllCheckedButtonClicked] = useState(false);
	const [remove, setRemove] = useState(false);
	const [pageNumber, setPageNumber] = useState(0);
	const [supplierInfo, setSupplierInfo] = useState(null);
	const supplierStore = useSelector((store) => store.supplierStore);
	const filterFields = useSelector((store) => store.filterFieldStore);
	const dispatch = useDispatch();
	const { id } = useParams();
	const scrollRef = useRef(null);

	useEffect(() => {
		// if (isAllCheckedButtonClicked) {
		// 	let materialIds = supplierInfo?.response?.data?.map((item) => item?.materialId);
		// 	setSelectedMaterials(materialIds || []);
		// }
		setSupplierInfo(supplierStore);
	}, [supplierStore]);

	useEffect(() => {
		setSelectedMaterials([]);
		setIsAllCheckedButtonClicked(false);
	}, [supplierType]);

	useEffect(() => {
		setIsLoading(true);
		dispatch(
			fetchSupplierTypeWiseList(
				id,
				supplierTypeWiseFieldParams(supplierType, filterFields, pageNumber),
				pageNumber !== 0
			)
		).finally(() => {
			setIsLoading(false);
		});
	}, [pageNumber, supplierType]);

	const handleSelectAllMaterial = (e) => {
		if (e.target.checked) {
			let materialIds = supplierInfo?.response?.data?.map((item) => item.materialId);
			setSelectedMaterials(materialIds);
			setIsAllCheckedButtonClicked(true);
		} else {
			setSelectedMaterials([]);
			setIsAllCheckedButtonClicked(false);
		}
	};

	const FABRIC_HEADERS = [
		{ label: '', checkbox: true, handleSelectAll: handleSelectAllMaterial },
		{ label: 'Image & category', checkbox: false },
		{ label: 'Supplier ref', checkbox: false },
		{ label: 'Composition', checkbox: false },
		{ label: 'Construction', checkbox: false },
		{ label: 'Weight', checkbox: false },
		{ label: 'Brand', checkbox: false },
		{ label: 'Price', checkbox: false },
		{ label: 'Action', checkbox: false }
	];
	const OTHER_HEADERS = [
		{ label: 'Image & name', checkbox: false },
		{ label: 'Reference', checkbox: false },
		{ label: 'Item details', checkbox: false },
		{ label: 'MOQ', checkbox: false },
		{ label: 'Price', checkbox: false },
		{ label: 'Lead time', checkbox: false },
		{ label: 'Capacity', checkbox: false },
		{ label: 'Rating', checkbox: false },
		{ label: 'Action', checkbox: false }
	];

	const handleScroll = () => {
		const wrappedElement = scrollRef.current;
		const remainingScroll =
			wrappedElement.scrollHeight - (wrappedElement.scrollTop + wrappedElement.clientHeight);
		if (remainingScroll <= 5) {
			let { totalElements, currentPage, data } = supplierInfo?.response || {};
			if (totalElements > 0 && totalElements !== data.length) {
				setPageNumber(currentPage + 1);
			}
		}
	};

	const onEdit = (e, item) => {
		e.stopPropagation();
		setSelectedItem(item);
		setIsEdit(supplierType);
	};

	const handleClose = () => {
		setRemove(false);
	};

	const handleMaterialSelection = (materialId) => {
		if (selectedMaterials.includes(materialId)) {
			setSelectedMaterials((prev) => prev.filter((item) => item !== materialId));
			setIsAllCheckedButtonClicked(false);
		} else {
			setSelectedMaterials((prev) => [...prev, materialId]);
		}
	};

	const onRemove = async () => {
		setIsLoading(true);
		await ApiClient.POST(
			'deleteSupplierMaterial',
			{},
			`?materialId=${selectedItem.materialId}&supplierId=${id}&requestedPage=SUPPLIER`
		)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					dispatch(fetchSupplierTypeWiseList(id, `?supplierType=${supplierType}`)).finally(() => {
						setIsLoading(false);
					});
					handleClose();
				}
			})
			.catch(() => {
				setIsLoading(false);
				handleClose();
				toastError('Request was unsuccessful.');
			});
	};

	const renderBrandList = (brandList = []) => {
		return brandList.map((item) => (
			<span className="brand-common-design mb-1 mr-1" key={item.id}>
				{item.name}
			</span>
		));
	};

	const onclose = (value) => {
		setIsEdit('');
		if (value !== undefined) {
			dispatch(fetchSupplierTypeWiseList(id, `?supplierType=${supplierType}`)).finally(() => {
				setIsLoading(false);
			});
		}
	};

	const updateEventLog = async (name, type) => {
		let eventData = {};
		eventData.productName = name;
		eventData.productType = type;
		await ApiClient.POST('updateMaterialEvent', eventData).catch(() => {
			toastError('Event was unsuccessful!');
		});
	};

	const renderEditModals = () => {
		let selectedRow = null;
		if (isEdit === 'FABRIC') {
			if (selectedItem !== null) {
				selectedRow = {
					leadTimeInDays: selectedItem.leadTimeInDays,
					price: selectedItem.price,
					moq: selectedItem.moq,
					capacity: selectedItem.capacity,
					brandResponseList: selectedItem.brandResponseList,
					supplierMaterialReferenceNumber: selectedItem.referenceNumber
				};
			}
			return (
				<TagSupplier
					show={true}
					handleClose={onclose}
					materialId={selectedItem?.materialId}
					supplierType={supplierType}
					supplierInfo={selectedRow}
				/>
			);
		} else if (isEdit === 'TRIMS' || isEdit === 'ACCESSORIES') {
			if (selectedItem !== null) {
				selectedRow = {
					price: selectedItem.price,
					pricePerUnit: selectedItem.pricePerUnit,
					leadTimeInDays: selectedItem.leadTimeInDays,
					capacity: selectedItem.capacity,
					capacityUnit: selectedItem.capacityUnit,
					itemRating: selectedItem.itemRating,
					moq: selectedItem.moq,
					description: selectedItem.description
				};
			}
			return (
				<TagMaterials
					show={true}
					handleClose={onclose}
					materialId={selectedItem?.materialId}
					supplierType={supplierType}
					id={id}
					materialInfo={selectedRow}
				/>
			);
		} else if (isEdit === 'EMBELLISHMENT') {
			return (
				<Embelishment
					materialData={selectedItem}
					isShow={true}
					onclose={onclose}
					viewType={'EDIT'}
					renderFrom={'MATERIAL_EDIT'}
					saveEventLog={updateEventLog}
				/>
			);
		} else if (isEdit === 'WASHING') {
			return (
				<Washing
					materialData={selectedItem}
					isShow={true}
					onclose={onclose}
					viewType={'EDIT'}
					renderFrom={'MATERIAL_EDIT'}
					saveEventLog={updateEventLog}
				/>
			);
		}
	};

	useEffect(() => {
		setIsShowMaterial(isAdd);
	}, [isAdd]);

	const onSetShowMaterial = () => {
		setIsShowMaterial(null);
		setIsAdd(null);
	};

	const CommonHeader = ({ label, checkbox, handleSelectAll }) => {
		return (
			<th>
				{checkbox ? (
					<div className="custom-chekbox">
						<div className="form-group m-0">
							<input
								type="checkbox"
								id="selectAll"
								name="selectAll"
								checked={
									supplierInfo?.response?.data?.length > 0 &&
									supplierInfo?.response?.data?.length === selectedMaterials?.length
								}
								onChange={handleSelectAll}
							/>
							<label htmlFor="selectAll" />
						</div>
					</div>
				) : (
					label
				)}
			</th>
		);
	};

	const renderTableHeading = () => {
		let headers = supplierType === 'FABRIC' ? FABRIC_HEADERS : OTHER_HEADERS;
		return <tr>{headers?.map((header, index) => CommonHeader({ key: index, ...header }))}</tr>;
	};

	const renderTableBody = () => {
		const supplierData = !isPopupView
			? (supplierInfo?.response?.data || []).slice(0, 5)
			: supplierInfo?.response?.data || [];

		if (supplierType === 'FABRIC') {
			return supplierData?.map((item) => {
				return (
					<tr key={`supplier_${item.materialId}`}>
						<td>
							<div className="custom-chekbox">
								<div className="form-group m-0">
									<input
										type="checkbox"
										id={`select_${item.materialId}`}
										name={`select_${item.materialId}`}
										checked={
											selectedMaterials.includes(item.materialId) ||
											isAllCheckedButtonClicked
										}
										onChange={() => handleMaterialSelection(item.materialId)}
									/>
									<label htmlFor={`select_${item.materialId}`} />
								</div>
							</div>
						</td>
						<td>
							<div className="d-flex align-items-center">
								<img
									src={
										item?.docUrl
											? item?.docUrl
											: `${process.env.PUBLIC_URL}/images/fabric-default.png`
									}
									className="cell-img pr-2"
									alt="supplier-image"
								/>
								<div className="ml-1">
									<p className="regular-14 gray_dark_01">{item?.construction}</p>
									<p className="regular-12 gray_dark_02">{item?.fabricType}</p>
								</div>
							</div>
						</td>
						<td>
							<p className="regular-14 gray_dark_02">{item?.supplierMaterialReferenceNumber}</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_02">{item?.compositionDetails}</p>
						</td>

						<td>
							<p className="regular-14 gray_dark_02">{item?.constructionDetails}</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_02">
								{item?.gsm} {item?.weightUnit}
							</p>
						</td>

						<td>
							<p className="regular-14 gray_dark_02">
								{renderBrandList(item?.brandResponseList)}
							</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_02">
								{item?.price ? `$${convertNumberToUSFormat(item.price)}` : ''}
							</p>
							<p className="regular-12 gray_dark_02">
								{item?.lastPriceModifiedAt
									? `(${convertDateToLocal(item.lastPriceModifiedAt, 'DD MMM, YY')})`
									: ''}
							</p>
						</td>
						<td>
							<div className="d-flex align-items-center">
								<span
									onClick={() => {
										navigator.clipboard.writeText(`${item.name} ${item.referenceNumber}`);
										toastSuccess('Copied');
									}}
								>
									<Tooltip title="Copy fabric" placement="top" arrow>
										<img
											src={`${process.env.PUBLIC_URL}/icons/copy-gray.svg`}
											alt="copy"
											className="copy"
										/>
									</Tooltip>
								</span>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
											aria-expanded="false"
										>
											<MoreIcon />
										</button>
										<ul
											className="dropdown-menu dropdown-menu-right shadow-lg"
											role="menu"
											aria-labelledby="menu1"
											x-placement="bottom-end"
										>
											<li role="presentation" className="px-4 pb-3 pt-3">
												<a
													href={void 0}
													role="menuitem"
													tabIndex={-1}
													onClick={(e) => onEdit(e, item)}
													className="font-weight-normal  text-black"
												>
													Edit tag info
												</a>
											</li>
											<li role="presentation" className="px-4 pb-3">
												<a
													href={void 0}
													role="menuitem"
													tabIndex={-1}
													className="font-weight-normal  text-black"
													onClick={() => {
														setRemove(true);
														setSelectedItem(item);
													}}
												>
													Delete
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</td>
					</tr>
				);
			});
		} else {
			return supplierData?.map((item) => {
				return (
					<tr key={`supplier_${item.materialId}`}>
						<td>
							<div className="d-flex align-items-center">
								<img
									src={
										item?.docUrl
											? item?.docUrl
											: `${process.env.PUBLIC_URL}/images/fabric-default.png`
									}
									className="cell-img pr-2"
									alt="supplier-image"
								/>
								<div className="ml-1">
									<p className="regular-14 gray_dark_01">{item?.name}</p>
								</div>
							</div>
						</td>
						<td>
							<p className="regular-14 gray_dark_02">{item?.referenceNumber}</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_02">{item?.itemDetails}</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_02">{item?.moq}</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_02">
								{item?.price ? `$${convertNumberToUSFormat(item.price)}` : ''}
							</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_02">{item?.leadTimeInDays}</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_02">{item?.capacity}</p>
						</td>
						<td>
							{item?.itemRating && (
								<div className="rating-score">
									<img src={`${process.env.PUBLIC_URL}/icons/star-filled.svg`} />
									<span className="semibold-16 rating-value">{item?.itemRating}</span>
								</div>
							)}
						</td>
						<td>
							<div className="d-flex align-items-center">
								<span
									onClick={() => {
										navigator.clipboard.writeText(`${item.name} ${item.referenceNumber}`);
										toastSuccess('Copied');
									}}
								>
									<Tooltip
										title={`${capitalizeFirstLetter(`Copy ${supplierType}`)}`}
										placement="top"
										arrow
									>
										<img
											src={`${process.env.PUBLIC_URL}/icons/copy-gray.svg`}
											alt="copy"
											className="copy"
										/>
									</Tooltip>
								</span>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
											aria-expanded="false"
										>
											<MoreIcon />
										</button>
										<ul
											className="dropdown-menu dropdown-menu-right shadow-lg"
											role="menu"
											aria-labelledby="menu1"
											x-placement="bottom-end"
										>
											<li role="presentation" className="px-4 pb-3 pt-3">
												<a
													href={void 0}
													role="menuitem"
													tabIndex={-1}
													onClick={(e) => onEdit(e, item)}
													className="font-weight-normal  text-black"
												>
													{supplierType === 'TRIMS' ||
													supplierType === 'ACCESSORIES'
														? 'Edit tag info'
														: 'Edit'}
												</a>
											</li>
											<li role="presentation" className="px-4 pb-3">
												<a
													href={void 0}
													role="menuitem"
													tabIndex={-1}
													className="font-weight-normal  text-black"
													onClick={() => {
														setRemove(true);
														setSelectedItem(item);
													}}
												>
													Delete
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</td>
					</tr>
				);
			});
		}
	};

	const renderStickerParams = () => {
		let params = supplierTypeWiseFieldParams(supplierType, filterFields);
		params += `&supplierId=${id}`;
		return params;
	};
	return (
		<>
			{supplierInfo?.response?.data?.length === 0 ? (
				<NoData message="No key products added" />
			) : (
				<div
					className="other-supplier-type scroll-y-label mt-3"
					ref={scrollRef}
					onScroll={handleScroll}
				>
					{/* <p className="mb-2">{supplierInfo?.response?.data?.length} Styles</p> */}
					<section className="filter-data-container p-0 pt-1 supplier-data-container bg-white">
						<div className="data-table">
							<div className="product-list-tabs-table ">
								<table className="table with-border">
									<thead>{renderTableHeading()}</thead>
									<tbody>{renderTableBody()}</tbody>
								</table>
							</div>
						</div>
						<DownloadSticker
							selectedMaterialIdList={selectedMaterials}
							setSelectedMaterialIdList={setSelectedMaterials}
							callback={() => setIsAllCheckedButtonClicked(false)}
							params={
								isAllCheckedButtonClicked
									? renderStickerParams(supplierType, filterFields)
									: `?supplierId=${id}&materialIdList=${selectedMaterials.join(
											','
										)}&supplierType=FABRIC`
							}
							count={
								isAllCheckedButtonClicked
									? supplierInfo?.response?.totalElements
									: selectedMaterials.length
							}
						/>
						{renderEditModals()}
						{remove && <DeleteModal onRemove={onRemove} onClose={handleClose} />}
						{isShowMaterial && (
							<div className="materials-tab-content on-supplier">
								<MaterialsLeftPanel
									isShowMaterial={true}
									onSetShowMaterial={onSetShowMaterial}
									onAddPin={() => false}
									isShowPin={false}
									isMainFabric={false}
									requestFrom="SUPPLIER"
									callback={(id) => {
										setSelectedMaterialId(id);
										setShowSupplier(true);
									}}
									visibleTabs={[supplierType]}
									selectedType={selectedType}
									setSelectedType={setSelectedType}
									isInventory={isInventory}
									setIsInventory={setIsInventory}
								/>
							</div>
						)}
						{supplierType === 'FABRIC' && (
							<TagSupplier
								show={showSupplier}
								handleClose={() => setShowSupplier(false)}
								materialId={selectedMaterialId}
								supplierType={supplierType}
							/>
						)}
						{(supplierType === 'TRIMS' || supplierType === 'ACCESSORIES') && (
							<TagMaterials
								show={showSupplier}
								handleClose={() => setShowSupplier(false)}
								materialId={selectedMaterialId}
								supplierType={supplierType}
								id={id}
							/>
						)}
					</section>
				</div>
			)}
		</>
	);
};

export default SupplierTypeWiseMaterialList;
